module.exports = __webpack_public_path__ + "img/null.bc12955e.png";